import React from 'react';
import { TextField, Typography } from '@mui/material';
import ResultsViewer from '../analyticsQa/ResultsViewer';
import StatusSelector from './StatusSelector';

import './building-fields-edit.css';

const FIELDS = [
  'address',
  'sq_ft',
  'timezone',
  'bms_manufacturer',
  'bms_product_name',
  'bms_version',
];
const API_FIELDS = {
  sq_ft: 'sqFt',
  bms_manufacturer: 'bmsManufacturer',
  bms_product_name: 'bmsName',
  bms_version: 'bmsVersion',
};
const TYPES = {
  sq_ft: 'number',
};

/**
 * Controlled component for editing building information fields
 */
const BuildingFieldsEdit = ({ building, changes, setChanges }) => (
  <div className="building-fields-edit" key={building.id}>
    <div>
      <div>
        <Typography>Building Status:</Typography>
        <StatusSelector
          selected={changes.status ?? building.status}
          onChange={(status) => setChanges({ status })}
        />
      </div>
    </div>
    {FIELDS.map((field) => (
      <TextField
        className={`building-field ${field}`}
        type={TYPES[field] || 'text'}
        key={field}
        label={field}
        value={changes[field] || building[API_FIELDS[field] || field] || ''}
        onChange={({ target: { value } }) => setChanges({ [field]: value })}
      />
    ))}
    <div className="building-info">
      <div>
        <Typography>Building info:</Typography>
      </div>
      <div>
        <ResultsViewer results={building.info} />
      </div>
    </div>
  </div>
);

export default BuildingFieldsEdit;
